import React from 'react';
import { CtaButton } from './CtaButton';
import { RatingProof } from './RatingProof';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/kYSRsu3XDu8Lut2a2yXpmF/Imagen_PPal.png';
const chips = ['6 Volumes', '90 Practices', '300 Pages', '90 · 75 · 60-min', '5 Bonuses'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it or run it from your phone'];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-plum-deep" data-id="element-109" data-mp="128pijeo72z53">
      <div className="relative mx-auto max-w-6xl px-5 pb-14 pt-8 md:pb-20 md:pt-12" data-id="element-110" data-mp="xbflpdyh7l78">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-111" data-mp="sai5h6x1118d">
          <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-112" data-mp="ncq0pcba9kmr">
            <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-113" data-mp="neklmqmk1cqu">
              The Two-Track Practice System · for wrestling coaches
            </p>
            <h1 className="mt-3 font-display font-semibold uppercase text-white text-[34px] leading-[1.05] tracking-tight sm:text-[42px] md:text-6xl lg:text-[64px]" data-id="element-114" data-mp="3814aznapvuna">
              Your whole season of wrestling practices,{' '}
              <span className="text-gold" data-id="element-115" data-mp="39acxmohxzmt0">already planned.</span>
            </h1>
          </div>

          {/* Product image: right after the headline on mobile, right column on desktop */}
          <figure className="lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-116" data-mp="3eb90qzugz4xd">
            <img src={HERO_IMAGE} alt="Wrestling Practice Ready, The Complete Season Megapack, standing on a wrestling mat in a gym" width={1024} height={1024} className="mx-auto aspect-square w-full max-w-[420px] rounded-xl object-cover shadow-cover ring-1 ring-plum-line md:max-w-[480px] lg:max-w-none" data-id="element-117" data-mp="30ggab6d1k4c0" />
          </figure>

          <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-118" data-mp="2hjymv1586qlk">
            <p className="max-w-xl text-base text-white/75 md:text-lg" data-id="element-119" data-mp="2ljgy1578vnb7">
              Six volumes with 90 numbered, ready-to-run practices, timed minute
              by minute, with a Rookie track and a Returner track on the same
              clock. Open the practice, pick your clock, run it.
            </p>

            <div className="mt-6 w-full md:max-w-md" data-id="element-120" data-mp="icrngo7ish86">
              <CtaButton data-id="element-121" data-mp="ddnhs7jt11ml">Get Wrestling Practice Ready</CtaButton>
            </div>

            <div className="mt-5 flex justify-center lg:justify-start" data-id="element-122" data-mp="1b0vv3f9nj4di">
              <RatingProof data-id="element-123" data-mp="1b04a0ydokp1h" />
            </div>

            <ul className="mt-6 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-124" data-mp="161b0fh1ili6l">
              {chips.map(chip => <li key={chip} className="rounded-md border border-plum-line bg-plum px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-white/75" data-id="element-125" data-mp="111err4hvh2kp">
                  {chip}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center border-t border-plum-line pt-6" data-id="element-126" data-mp="3hq27r1skmeby">
          <p className="max-w-md text-center text-sm text-white/70" data-id="element-127" data-mp="1xb5pse406rg4">
            Written for head coaches, assistants, club volunteers and PE
            teachers who run their own practices. Folkstyle-first, with
            freestyle notes. No subscription.
          </p>
          <ul className="mt-4 flex flex-col items-center gap-2 text-xs text-white/60 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-5" data-id="element-128" data-mp="2b1r923xdd3ej">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-129" data-mp="2kydsqpdyloez">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-130" data-mp="2l0qbv5vge4tm" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}